import React, { useState } from 'react'
import { startRegistration } from '@simplewebauthn/browser'
import { FaKey } from 'react-icons/fa'
import { Box, Button, Icon, Text } from '@/components/lib'
import utils from '../../utils/utils'
import api from '../../api'

// Register a new passkey on the signed-in account: runs the WebAuthn ceremony
// in the browser and stores the resulting credential. Used from the security
// settings page and from the enrolment screen.
//
// There is no name prompt. Nobody knows what to call a passkey, so the API
// names it after the provider or device that made it ("iCloud Keychain",
// "Chrome on Windows") and it can be renamed from settings afterwards.
//
// `onComplete(data)`: called with the API response. During enrolment that
// carries the account's new full session token.
export default function PasskeyRegistration ({ onComplete, buttonLabel = 'Create passkey' }) {
  const [registering, setRegistering] = useState(false)

  async function register () {
    setRegistering(true)
    api.accounts.getPasskeyRegistrationOptions(async options => {
      try {
        const credential = await startRegistration({ optionsJSON: options })
        api.accounts.registerPasskey(credential, data => {
          setRegistering(false)
          onComplete && onComplete(data)
        }, err => {
          setRegistering(false)
          utils.toast('error', 'Unable to add your passkey', err.message)
        })
      } catch (err) {
        setRegistering(false)
        if (err?.name !== 'NotAllowedError' && err?.name !== 'AbortError') {
          utils.toast('error', 'Unable to add your passkey', err.message)
        }
      }
    }, err => {
      setRegistering(false)
      utils.toast('error', err.message)
    })
  }

  return (
    <Box>
      <Text mb={3} fontSize='sm' color='fg.muted'>Your browser or password manager will ask you to confirm with your fingerprint, face, PIN or security key.</Text>
      <Button colorPalette='primary' onClick={register} isLoading={registering}><Icon as={FaKey} mr={2} /> {buttonLabel}</Button>
    </Box>
  )
}
